import getApi from '@/lib/axios';

async function createRecomendation({id, text}) {
  const api = await getApi();
  const payload = {
    aluno: id,text
  };

  const { data } = await api.post('/aluno/recomendacao/', payload);

  return data;
}

export { createRecomendation };

